export enum SemanticCode {
  WorkflowList = 'workflow-list',
  WorkflowEditor = 'workflow-editor',
  AggregatorProcessList = 'aggregator-process-list',
  AggregatorList = 'aggregator-list',
  AggregatorEditor = 'aggregator-editor',
}
